

export interface INotificationToken {
    timestamp: string;
    token: string;
}

export class NotificationToken implements INotificationToken {
    timestamp: string;
    token: string;
    
    constructor(obj?:any) {
        this.timestamp = obj && obj.timestamp || '';
        this.token = obj && obj.token || '';
    }

    toFirestore(): any {
        return {
            timestamp: this.timestamp,
            token: this.token
        }
    }
}